<div class="switch-view-container">
  <ng-container *ngIf="(state | async).analyses.length; else noAnalyses">
    <div
      class="table-container uk-margin"
      [ngClass]="{
        'table-height-user': (state | async).analyses.length && url.includes('users'),
        'table-height-pitch': (state | async).analyses.length && url.includes('pitches')
      }">
      <table class="uk-table uk-table-justify uk-table-divider uk-table-striped uk-table-hover uk-table-small uk-table-middle">
        <thead>
          <tr>
            <th class="uk-text-nowrap" i18n="@@analysisTitle">analysis title</th>

            <th class="uk-text-nowrap" i18n="@@analysis">analysis</th>

            <th class="uk-text-nowrap" i18n="@@pitch" *ngIf="!url.includes('pitches')">pitch</th>

            <th class="uk-text-nowrap" i18n="@@author" *ngIf="!url.includes('users')">author</th>

            <th class="uk-table-shrink uk-text-right" i18n="@@status">status</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let analysis of (state | async).analyses">
            <td>{{ analysis.title }}</td>

            <td>
              <ng-container *ngIf="analysis.text.length <= 70; else showModal">
                {{ analysis.text }}
              </ng-container>

              <ng-template #showModal>
                <span appFullText [title]="analysis.title" [text]="analysis.text" [modal]="modal" class="pointer">
                  {{ analysis.text.substr(0, 67) + '...' }}
                </span>
              </ng-template>
            </td>

            <td *ngIf="!url.includes('pitches')">
              <a [routerLink]="['/pitches', analysis.pitch.id]">{{ analysis.pitch.name }}</a>
            </td>

            <td *ngIf="!url.includes('users')">
              <ng-container *ngIf="analysis.user.first_name && analysis.user.last_name; else email">
                <a [routerLink]="['/users', analysis.user.id]">
                  {{ analysis.user.first_name + ' ' + analysis.user.last_name | titlecase | namesWithDash }}
                </a>
              </ng-container>

              <ng-template #email>
                <a [routerLink]="['/users', analysis.user.id]">
                  {{ analysis.user.email | userWithoutName }}
                </a>
              </ng-template>
            </td>

            <td class="uk-text-center switcher-container">
              <app-status-switcher [action]="action" [eyeIcon]="true" [id]="analysis.id" [status]="analysis.muted"> </app-status-switcher>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #noAnalyses>
    <div *ngIf="(state | async).alreadyRequested.includes(switchViews.Analyses)" class="uk-text-center" i18n="@@noAnalysesUser">
      There are no analyses related to the user.
    </div>
  </ng-template>
</div>
